import Materials_A from './Materials_A'

const Materials = {
  A: Materials_A
}

export default Materials



// WEBPACK FOOTER //
// ./src/components/Materials.js